import {
	createSlice,
	createEntityAdapter,
	createAsyncThunk,
} from "@reduxjs/toolkit";
import { formulaEdited } from "./formulasSlice";

import { parser } from "components/Parser";

const answersAdapter = createEntityAdapter();

const initialState = answersAdapter.getInitialState({
	status: "idle",
	error: null,
});

// export const answerRemoved = createAsyncThunk(
// 	"answer/answerRemoved",
// 	async (id, { getState, dispatch }) => {
// 		const state = getState();
// 		const answers = selectAllAnswers(state);
// 		const answer = answers.find((a) => a.id === id);
// 		//trigger an answer upsert with a null value
// 		//this ensures that dependencies are updated as expected
// 		if (answer) dispatch(answerUpserted({ ...answer, value: null }));
// 	}
// );

export const answerUpserted = createAsyncThunk(
	"answer/answerUpserted",
	//need the thunkApi's getState to retrieve auth token
	async (action, { getState, dispatch }) => {
		//call the answer reducer
		dispatch(answerEdited(action));

		//get the row of the action, for child questions
		const { row } = action;

		//grab all state we need for formula calculations
		const { dependencies, formulas, answers } = getState();

		//returns an array of formulas that depend on the value that just changed
		let dependentFormulas =
			dependencies.entities[action.questionId]?.formulas;

		if (dependentFormulas && dependentFormulas.length > 0) {
			dependentFormulas.forEach((d) => {
				//get all of the dependencies of this formula
				const formula = formulas.entities[d];
				formula.dependencies.forEach((sd) => {
					let id = row ? row[sd] : sd; //if null, try get a non-instance value
					//todo: replace parseFloat with a more accurate and safe method
					let value = answers.entities[id]?.value;
					parser.setVariable(
						sd,
						!Array.isArray(value)
							? answers.entities[id]?.dataType !== "string" &&
							  typeof value === "number"
								? parseFloat(value || 0)
								: value
							: value.join(",")
					);
				});

				const { error, result } = parser.parse(formula.text);

				if (error) {
					dispatch(formulaEdited({ ...formula, error: error }));
				} else {
					//if child value, stored on an object with rowId as key
					//else stored as value primitive
					const valuesByRow = row
						? { ...formula.valuesByRow, [row.id]: result }
						: { ...formula.valuesByRow };
					const value = row ? formula.value : result;
					dispatch(
						formulaEdited({
							...formula,
							valuesByRow: valuesByRow,
							value: value,
							error: null,
						})
					);
				}
			});
		}
	}
);

const answersSlice = createSlice({
	name: "answer",
	initialState,
	reducers: {
		answerAdded(state, action) {
			answersAdapter.addOne(state, action.payload);
		},
		answerEdited(state, action) {
			answersAdapter.upsertOne(state, action.payload);
		},
		answersReceived(state, action) {
			answersAdapter.setAll(state, action.payload);
		},
		answerRemoved(state, action) {
			answersAdapter.removeOne(state, action.payload);
		},
	},
});

export const { answerAdded, answerEdited, answersReceived, answerRemoved } =
	answersSlice.actions;

/*
SELECTORS
*/
export const { selectAll: selectAllAnswers, selectById: selectAnswerById } =
	answersAdapter.getSelectors((state) => state.answers);

export const selectAnswersError = (state) => state.answers.error;

export default answersSlice.reducer;
